<template>
  <div class="upload-file">
    <el-upload
      class="upload-demo"
      :show-file-list="false"
      :action="apiUrl + '/ticCenter/business/api.v0.platform/fileUpload/uploadPrivate'"
      :before-upload="beforeUpload"
      :on-success="onSuccess"
      :on-error="onError"
      :on-exceed="handleExceed"
      :disabled="uploadDisabled || fileList.length >= limit"
    >
      <slot name="btn" :loading="uploadDisabled" :disabled="fileList.length >= limit">
        <div class="upload-btn" v-loading="uploadDisabled">+</div>
      </slot>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: {
    limit: {
      type: Number,
      default: 1,
    },
    value: {
      type: [Array, String],
      default() {
        return []
      }
    },
    type: {
      type: Number,
      default: 1
    },
    side: {
      type: String,
      default: ''
    },
    bindKey: {
      type: String,
      default: ''
    },
    apiUrl: {
      type: String,
      default: ''
    },
    apis: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      fileList: [],
      uploadDisabled: false,
    }
  },
  watch: {
    value: {
      handler(val) {
        if (typeof val === 'object' && val && val.length) {
          this.fileList = JSON.parse(JSON.stringify(val))
        } else {
          this.fileList = []
        }
      },
      immediate: true
    }
  },
  methods: {
    beforeUpload(file) {
      const isLt20M = file.size / 1024 / 1024 < 20;
      let isImg = true

      if (this.fileList.length > this.limit) {
        this.$message.warning(`最多上传${this.limit}个文件`);
        return false
      }
      if (!/\.(jpg|jpeg|png|pdf)$/.test(file.name.toLocaleLowerCase())) {
        this.$message.error('上传文件类型必须是jpg、jpeg、png、pdf');
        isImg = false
      }

      if (!isLt20M) {
        this.$message.error('上传文件大小不能超过 20MB!');
      }
      if (isLt20M && isImg) {
        this.uploadDisabled = true
      }
      return isLt20M && isImg;
    },
    // 上传附件成功
    onSuccess(res, file, fileList) {
      if (res.resultCode === "0") {
        const data = res.data
        this.apis.getDownUrl({fileId: data.fileId}).then(res1=> {
          this.uploadDisabled = false
          data.fileUrl = res1.data.fileUrl
          this.$message.closeAll()
          this.fileList.push(data)
          this.$emit('input', JSON.parse(JSON.stringify(this.fileList)))
          this.$emit('validateImg', this.bindKey)
          // ocrImg({
          //   type: 1,
          //   image: res1.data.fileUrl,
          //   fileName: data.fileName,
          //   configure: {side: this.side}
          // }).then(res2 => {
          //   this.uploadDisabled = false
          //   this.fileList.push(data)
          //   this.$emit('input', JSON.parse(JSON.stringify(this.fileList)))
          // }).catch(e => {
          //   this.uploadDisabled = false
          //   if (e && e.resultCode === '3105') {
          //     this.$message.closeAll()

          //     this.$confirm(`您上传的证件 <span style="color: red;">${this.type === 1 ? '营业执照' : '身份证'}</span> 可能无法正确识别，请确认是否需要重新上传`, '信息', {
          //       confirmButtonText: '继续提交',
          //       cancelButtonClass: '重新上传',
          //       // type: 'warning',
          //       // center: true,
          //       dangerouslyUseHTMLString: true
          //     }).then(() => {
          //       this.fileList.push(data)
          //       this.$emit('input', JSON.parse(JSON.stringify(this.fileList)))
          //       this.$emit('validateImg', this.bindKey)
          //     }).catch()
          //   }
          // })
        }).catch(e => {
          this.uploadDisabled = false
        })

      } else {
        this.uploadDisabled = false
        this.$message.error(res.resultMsg)
      }
    },
    handleExceed(files, fileList) {
    },
    onError(res, file, fileList) {
      this.uploadDisabled = false
      this.$message.error('网络异常')
    }
  }
}
</script>

<style scoped lang="scss">
  .upload-btn {
    display: inline-block;
    width: 60px;
    height: 60px;
    background: #FFFFFF;
    border: 1px dashed #D2D2D2;
    font-size: 36px;
    color: #BDBDBD;
    line-height: 58px;
    text-align: center;
  }
  .upload-file {
    margin-right: 20px;
  }
</style>
